// @ts-nocheck

export const localeCodes =  [
  "de",
  "en"
]
export const localeLoaders = {
  de: [],
  en: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    language: "de-CH",
    dir: "ltr",
    siteLocale: "de",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "en",
    language: "en",
    dir: "ltr",
    siteLocale: "en",
    domains: [],
    defaultForDomains: []
  }
]

